// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rl-0";